import { GroupsContent } from "content";
import { ContentModal } from "components/Common/ContentModal";
import { AddGroupForm } from "../AddGroupForm";
import { TGroup } from "types/api/groups";
import "./EditGroupModal.styles.scss";

type EditGroupModalProps = {
  /**
   * If `true`, the modal is shown.
   *
   * @default false
   */
  open?: boolean;
  /**
   * Callback fired when the component requests to be closed.
   */
  onClose: () => void;
  /**
   * Group data to edit.
   */
  group?: TGroup;
};

export const EditGroupModal: React.FC<EditGroupModalProps> = (props) => {
  const { open = false, onClose, group } = props;

  return (
    <ContentModal
      portalId="edit-group-modal"
      footerId="edit-group-modal-footer"
      open={open}
      title={GroupsContent.Edit.TITLE}
      emoji={GroupsContent.Edit.EMOJI}
      onClose={onClose}
    >
      <AddGroupForm onSubmit={onClose} initialData={group} isEditMode={true} />
    </ContentModal>
  );
};
